import apiClient from '@/services/axios'

export async function get(folderId, venueId) {
  let response;
  console.log("FOLDERID", folderId, venueId);
  if (folderId == "")
    response = await apiClient.get(`/VenueDrive/ListDirectory?venueId=${venueId}`);
  else
    response = await apiClient.get(`/VenueDrive/ListDirectory?directory=${folderId}&venueId=${venueId}`);
  if (response) {
    return response.data
  }

  throw new Error('Unable to get files in scope')
}